// Aqui recibes los datos de inicializacion (whitelabel + user)
// Tambien se recibe del server la estructura del sidebar_tutor
// Es necesario definir las variables de las secciones(Principal,Otro,etc) al principio de la clase
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { SwUpdate } from '@angular/service-worker';

import { MenuController, Platform, ToastController } from '@ionic/angular';

import { Storage } from '@ionic/storage';

import { UserData } from './providers/user-data';

import { Browser } from '@capacitor/browser';
import { ApiData } from './providers/api'

import { MockData } from './providers/mock-data'

import { FcmService } from './services/firebase/fcm.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {
  // Aqui defines las secciones del sidebar
  Sidebar: any[] = []
  Otro: any[] = []

  loggedIn = false;
  dark = false;
  version : any


  async centro_ayuda() {
    const data = await ApiData.centro_ayuda()
    Browser.open({ url: data.message })
  }

  async privacidad() {
    const data = await ApiData.privacidad()
    Browser.open({ url: data.message })
  }

  constructor(
    public mockdata: MockData,
    private menu: MenuController,
    private platform: Platform,
    private router: Router,
    // private splashScreen: SplashScreen,
    // private statusBar: StatusBar,
    private storage: Storage,
    private userData: UserData,
    private swUpdate: SwUpdate,
    private toastCtrl: ToastController,
    private fcmService: FcmService,
  ) {
    this.initializeApp();
  }

  async ngOnInit() {
    await this.storage.create()

    const data = await ApiData.movil_app_config()
    this.Sidebar = data.message
    // console.log('sidebar')
    // console.log(this.Sidebar)
    // if (data.message) {
    //   this.check_version(data.message[2])
    //   this.version = data.message[2]
    // } else { console.log('respuesta error ', data)  }

    // await this.mockdata.movil_app_config().subscribe((data: any) => {
    //   if (data.message) {
    //     // console.log('App component response ', data.message)
    //     this.Sidebar = data.message
    //     console.log(this.Sidebar)
    //     this.Otro = data.message[0].otro
    //     this.check_version(data.message[0].version)
    //     this.version = data.message[0].version
    //   } else {   console.log('respuesta error ', data) }
    // })


    this.checkLoginStatus();
    this.listenForLoginEvents();

    this.swUpdate.available.subscribe(async res => {
      const toast = await this.toastCtrl.create({
        message: 'Update available!',
        position: 'bottom',
        buttons: [
          {
            role: 'cancel',
            text: 'Reload'
          }
        ]
      });

      await toast.present();

      toast
        .onDidDismiss()
        .then(() => this.swUpdate.activateUpdate())
        .then(() => window.location.reload());
    });
  }

  async check_v(){
    this.check_version(this.version)
  }

  async check_version(v){
    await this.userData.getVersion().then((c) => {
      console.log('consoleando c',c)
      console.log('consoleando version',v)
      if (v != c) {
        this.update(v)
      }
    })
  }


  async update(v) {
    const toast = await this.toastCtrl.create({
      message: 'Actualizacion Disponible!',
      position: 'middle',
      buttons: [
        {
          role: 'cancel',
          text: 'Actualizar'
        }
      ]
    });

    await toast.present();

    toast
      .onDidDismiss()
      .then(() => this.userData.setVersion(v))
      .then(() => window.location.reload());

  }

  initializeApp() {
    this.platform.ready().then(() => {
      // this.statusBar.styleDefault();
      // this.splashScreen.hide();
      console.log('initialize')

      // this.fcmService.initPush();
    });
  }

  checkLoginStatus() {
    return this.userData.isLoggedIn().then(loggedIn => {
      return this.updateLoggedInStatus(loggedIn);
    });
  }

  updateLoggedInStatus(loggedIn: boolean) {
    setTimeout(() => {
      this.loggedIn = loggedIn;
    }, 300);
  }

  listenForLoginEvents() {
    window.addEventListener('user:login', () => {
      this.updateLoggedInStatus(true);
    });

    window.addEventListener('user:signup', () => {
      this.updateLoggedInStatus(true);
    });

    window.addEventListener('user:logout', () => {
      this.updateLoggedInStatus(false);
    });
  }

  logout() {
    this.userData.logout().then(() => {
      return this.router.navigateByUrl('/login');
    });
  }

  // openTutorial() {
  //   this.menu.enable(false);
  //   this.storage.set('ion_did_tutorial', false);
  //   this.router.navigateByUrl('/tutorial');
  // }
}
